
import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import { Form as ElForm } from 'element-ui'
import {
  getExchangeRateList,
  addExchangeRate,
  setExchangeRate,
  delExchangeRate
} from '@/api/merchant/fund'
import { exchangeRateRules } from '@/utils/rules'
import { AppModule } from '@/store/modules/app'

@Component
export default class extends Vue {
  @Prop({ required: true }) merchant_no!: string
  @Prop({ required: false, default: false }) openRateDialog!: boolean
  private listLoading: boolean = false
  private loading: boolean = false
  private exchangeRateList: any[] = []
  private dialogVisible: boolean = false
  private setForm: any = {
    base_currency: '',
    quote_currency: '',
    mode: '',
    bid: '',
    ask: ''
  }
  private rules = exchangeRateRules
  private baseCurrencyTypes: any[] = AppModule.enterprise.available_currency
  private quoteCurrencyTypes: any[] = []

  private flag: boolean = false
  // 按钮只触发一次
  private flagStr () {
    setTimeout(() => {
      this.flag = false
    }, 500)
  }

  @Watch('openRateDialog', { immediate: true })
  onOpenRateDialogChange () {
    this.openRateDialog ? this.openDialog(null) : this.$emit('close')
  }

  selectBaseCurrency () {
    this.setForm.quote_currency = ''
    this.quoteCurrencyTypes = this.baseCurrencyTypes.filter(item => {
      return (
        item !== this.setForm.base_currency &&
        this.exchangeRateList
          .filter(rate => {
            return rate.base_currency === this.setForm.base_currency
          })
          .map(f_rate => {
            return f_rate.quote_currency
          })
          .indexOf(item) === -1
      )
    })
  }

  private async getList () {
    this.listLoading = true
    try {
      await getExchangeRateList({ merchant_no: this.merchant_no }).then(
        (res: any) => {
          this.exchangeRateList = res
          this.listLoading = false
        }
      )
    } catch (e) {
      this.listLoading = false
    }
  }

  save () {
    ;(this.$refs.setForm as ElForm).validate(async (valid: boolean) => {
      if (valid) {
        this.setForm.id ? this.setRate() : this.create()
      }
    })
  }

  async setRate () {
    const data: any = {
      merchant_no: this.merchant_no,
      ...this.setForm
    }
    try {
      this.loading = true
      this.flag = true
      await setExchangeRate(data).then((res: any) => {
        this.$message({
          message: 'Change successful!',
          type: 'success'
        })
        this.loading = false
        this.flagStr()
        this.close()
        this.getList()
      })
    } catch (e) {
      this.loading = false
      this.close()
    }
  }

  async create () {
    const data: any = {
      merchant_no: this.merchant_no,
      ...this.setForm
    }
    try {
      this.loading = true
      this.flag = true
      await addExchangeRate(data).then((res: any) => {
        this.$message({
          message: 'Crated successful!',
          type: 'success'
        })
        this.loading = false
        this.flagStr()
        this.close()
        this.getList()
      })
    } catch (e) {
      this.loading = false
      this.flagStr()
    }
  }

  private openDialog (obj: any) {
    if (obj) {
      this.setForm = obj
    }
    this.dialogVisible = true
  }

  private close () {
    this.setForm = {
      base_currency: '',
      quote_currency: '',
      mode: '',
      bid: '',
      ask: ''
    }
    this.dialogVisible = false
    this.$emit('close')
  }

  private async delRate (obj) {
    const data: any = {
      merchant_no: this.merchant_no,
      id: obj.id
    }
    await delExchangeRate(data).then(() => {
      this.$message({
        message: 'Delete successful!',
        type: 'success'
      })
      this.getList()
    })
  }

  // 删除
  private del (obj: any) {
    this.$confirm('Are you sure to delete it?', {
      confirmButtonText: 'Yes',
      cancelButtonText: 'Cancel',
      type: 'warning',
      callback: action => {
        if (action === 'confirm') {
          this.delRate(obj)
        }
      }
    })
  }

  mounted () {
    this.getList()
  }
}
